<template>
  <section>
    <b-button
      size="lg"
      variant="outline-default"
      @click="$bvModal.show(`series-categories-${uuid}`)"
    >{{ $t('series-category-selector-button.label') }}</b-button>
    <b-modal
      centered
      size="lg"
      :id="`series-categories-${uuid}`"
      :title="$t('series-category-selector-button.modal.series-category-selector.title')"
    >
      <b-list-group>
        <b-list-group-item
          href="#"
          v-for="category in categories"
          :key="category.cag_no"
          @click="select(category.cag_no)"
        >{{ $i18n.locale === 'tw' ? category.cag_name : category.cag_name_en }}[{{ category.cag_no }}]</b-list-group-item>
      </b-list-group>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Vue from 'vue'
import UUID from '@estudioliver/vue-uuid-v4'
import { ButtonPlugin, ListGroupPlugin, ModalPlugin } from 'bootstrap-vue'

Vue.use(ButtonPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(UUID)

export default {
  name: 'series-category-selector-button',
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      uuid: null
    }
  },
  methods: {
    select(category_no) {
      this.$emit('select', category_no);
      this.$bvModal.hide(`series-categories-${this.uuid}`);
    }
  },
  created() {
    this.uuid = this.$uuidKey()
  }
}
</script>
